export default __webpack_public_path__ + "static/media/ic_checked.7af5377f.svg";